<template>
  <div class="col-12">
    <div class="card">
      <div class="card-header bg-teal-400 d-flex justify-content-between">
        {{ formattedHeaderDates.startDate }} -
        {{ formattedHeaderDates.endDate }}
      </div>
      <div class="card-body">
        <content-loader
          v-if="isLoading"
          :speed="6"
          :animate="true"
          primaryColor="#262d3c"
          secondaryColor="#384257"
        >
          <rect x="10" y="15" rx="2" ry="2" width="300" height="5" />
          <rect x="10" y="25" rx="2" ry="2" width="220" height="5" />

          <rect x="10" y="35" rx="2" ry="2" width="300" height="5" />
          <rect x="10" y="45" rx="2" ry="2" width="220" height="5" />

          <rect x="10" y="55" rx="2" ry="2" width="300" height="5" />
          <rect x="10" y="65" rx="2" ry="2" width="220" height="5" />

          <rect x="10" y="75" rx="2" ry="2" width="300" height="5" />
          <rect x="10" y="85" rx="2" ry="2" width="220" height="5" />

          <rect x="10" y="95" rx="2" ry="2" width="300" height="5" />
          <rect x="10" y="105" rx="2" ry="2" width="220" height="5" />
        </content-loader>

        <table v-else id="printData" class="table table-striped">
          <tr>
            <th></th>
            <th v-for="(column, index) in columnsToShow" v-bind:key="index">
              {{ column.name }}
            </th>
          </tr>
          <template v-for="(data, index) in employeesToShow">
            <tr :key="index">
              <td>
                {{ data.employee.name }}
              </td>
              <td v-for="(total, index) in columnsToShow" v-bind:key="index">
                {{ data[total.dataName].toFixed(2) }}
              </td>
            </tr>
            <template v-if="jobSpecificTimes && !fromHoursWorked">
              <tr
                v-for="(value, key) in jobSpecificTotals[
                  jobSpecificTotals.findIndex(
                    x => x.employee.id === data.employee.id
                  )
                ].ot"
                :key="`${key}-${data.employee.id}`"
              >
                <td class="text-center">{{ getJobName(key) }}</td>
                <td>
                  {{
                    jobSpecificTotals[
                      jobSpecificTotals.findIndex(
                        x => x.employee.id === data.employee.id
                      )
                    ].regular[`${key}`].toFixed(2)
                  }}
                </td>
                <td>{{ value.toFixed(2) }}</td>
              </tr>
            </template>
            <template v-if="jobSpecificTimes && fromHoursWorked">
              <tr
                v-for="(value, key) in hoursWorkedJobSpecificTotals[
                  hoursWorkedJobSpecificTotals.findIndex(
                    x => x.employee.id === data.employee.id
                  )
                ].ot"
                :key="`${key}-${data.employee.id}`"
              >
                <td class="text-center">{{ getJobName(key) }}</td>
                <td>
                  {{
                    hoursWorkedJobSpecificTotals[
                      hoursWorkedJobSpecificTotals.findIndex(
                        x => x.employee.id === data.employee.id
                      )
                    ].regular[`${key}`].toFixed(2)
                  }}
                </td>
                <td>{{ value.toFixed(2) }}</td>
              </tr>
            </template>
          </template>

          <tr>
            <td></td>
            <td v-for="(total, index) in columnsToShow" v-bind:key="index">
              {{ total.value.toFixed(2) }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div v-if="timeCardCollection.length > 0">
      <div v-for="employee in timeCardCollection" :key="employee.employee.id">
        <!-- v-if="employee.hasTimeCards" -->
        <report-calculations
          :timeCardCollection="employee.timeCardCollection"
          :employee="employee.employee"
          :searchDate="searchDate"
          :holidays="holidays"
          :holidaysInTimeSpan="holidaysInTimeSpan"
          @updateData="updateData"
          @updateStatCards="updateStatCards"
          style="display: none"
        ></report-calculations>
        <!-- 
          @updateStatTotals="updateStatTotals"
         -->
      </div>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex';
import reportCalculations from '../childComponents/reportCalculations.vue';
import { db } from '../../assets/js/firebase/db.js';
import moment from 'moment';
import { getHolidays } from '../../assets/js/helpers/holidays.js';
import { ContentLoader } from 'vue-content-loader';
import { getWeeksFromDateRange } from '../../assets/js/helpers/dates.js';
import { roundToQuarter } from '../../assets/js/helpers/hoursCalculations.js';

export default {
  name: 'allEmployeesPayrollv2',
  components: {
    ContentLoader,
    reportCalculations
  },
  data() {
    return {
      totals: [],
      hoursWorkedTotals: [],
      tableData: [],
      allEmployeeTotals: [],
      allEmployeeJobSpecificTotals: [],
      jobSpecificTotals: [],
      hoursWorkedJobSpecificTotals: [],
      holidays: [],
      holidaysInTimeSpan: [],
      timeCardCollection: [],
      statTimeCards: [],
      isLoading: null,
      missingTimeCardError: false,
      missingTimeCardMessage: null,
      duplicateTimeCardErrors: []
    };
  },
  props: {
    hideEmployeesWithNoHours: Boolean,
    users: Array,
    searchDate: Array,
    fromHoursWorked: Boolean
  },
  methods: {
    calculateAllEmployees: async function() {
      this.$store.commit('clearEmployeeStatTime');
      this.timeCardCollection = [];
      this.tableData = [];
      this.holidays = [];
      this.holidaysInTimeSpan = [];
      this.isLoading = true;
      let promises = [];
      let promiseData = [];

      //need to split the date range into weeks, so we can do weekly OT calculations.
      let weeks = getWeeksFromDateRange(this.searchDate[0], this.searchDate[1]);
      await this.getHolidays(this.searchDate[0], this.searchDate[1]);
      this.calculateHolidays();

      //if the search for is valid, loop through all employees and get their timecards.
      if (weeks.length > 0) {
        for (let i = 0; i < this.users.length; i++) {
          if (this.users[i].id !== 'all') {
            //loop through each week and get the timecards for that user for each week.
            for (let weekIndex = 0; weekIndex < weeks.length; weekIndex++) {
              let startDate = moment(weeks[weekIndex].startOfWeek).startOf(
                'day'
              );
              let endDate = moment(weeks[weekIndex].endOfWeek).endOf('day');
              promises.push(
                db
                  .collection('timeCards')
                  .where('date', '>=', new Date(startDate))
                  .where('date', '<=', new Date(endDate))
                  .where('company', '==', this.$store.state.userCompany)
                  .where('user', '==', this.users[i].id)
                  .get()
              );
              promiseData.push({
                employee: this.users[i],
                startDate: startDate,
                endDate: endDate,
                weekIndex: weekIndex
              });
            }
          }
        }
      }
      //go through all timecard data, calculate weekly overtime, and add to timeCardCollection
      try {
        let allSnapshots = await Promise.all(promises);
        allSnapshots.forEach((querySnapshot, snapshotIndex) => {
          let employee = promiseData[snapshotIndex].employee;
          let startDate = promiseData[snapshotIndex].startDate;
          let endDate = promiseData[snapshotIndex].endDate;
          let weekIndex = promiseData[snapshotIndex].weekIndex;

          let tempArg = {
            timeCards: []
          };
          let holidayWeek = false;
          let holidayDate = null;
          let employeeWorkedHoliday = false;
          this.holidaysInTimeSpan.forEach(holiday => {
            if (
              moment(holiday).isBetween(startDate, endDate, undefined, '[]')
            ) {
              holidayWeek = true;
              holidayDate = holiday;
            }
          });

          querySnapshot.forEach(doc => {
            let date = moment(doc.data().date.toDate()).format('MMM DD, YY');
            if (this.holidaysInTimeSpan.includes(date)) {
              employeeWorkedHoliday = true;
            }
            let complete = true;
            for (let i = 0; i <= doc.data().times.length - 1; i++) {
              if (doc.data().times[i].endTime == null) {
                complete = false;
              }
            }
            if (complete) {
              //only going to display time cards that have an end time on this.
              if (doc.data().approved == false) {
                //there are time cards that are not approved in this time frame.
                this.missingTimeCardError = true;
                this.missingTimeCardMessage =
                  'There are time cards in the selected time frame that are not approved.';
              } else {
                tempArg.timeCards.push({
                  id: doc.id,
                  date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                  times: doc.data().times,
                  approved: doc.data().approved,
                  approvedBy:
                    doc.data().approvedBy == undefined
                      ? null
                      : doc.data().approvedBy,
                  name: doc.data().name,
                  type: doc.data().type,
                  dateApproved:
                    doc.data().dateApproved == undefined
                      ? null
                      : moment(doc.data().dateApproved.toDate()).format(
                          'MMM DD, YY hh:mm'
                        ),
                  vacation: doc.data().vacation,
                  uid: doc.data().user,
                  averagingAgreement: doc.data().averagingAgreement
                    ? doc.data().averagingAgreement
                    : null,
                  editComment: doc.data().editComment
                });
              }
            } else {
              //there are incomplete time cards.
              this.missingTimeCardError = true;
              this.missingTimeCardMessage =
                'There are ongoing time cards in the selected time frame.';
            }
          });
          let sum = 0;
          let index = -1;
          let lastHours = 0;
          let dayAdd = 0;

          if (holidayWeek && !employeeWorkedHoliday) {
            tempArg.timeCards.push({
              id: `${employee.id}-${holidayDate}`,
              date: holidayDate,
              times: [
                {
                  startTime: moment(holidayDate).startOf('day'),
                  endTime: moment(holidayDate).startOf('day'),
                  type: 'regular'
                }
              ],
              approved: true,
              approvedBy: 'holiday',
              name: employee.name,
              type: employee.type,
              dateApproved: holidayDate,
              vacation: 'null',
              uid: employee.id
              // otIndex: null,
              // lastRegTime: null
            });
          }
          //sort the time cards by date because we possibly added a time card for the holiday at the end of the array.
          tempArg.timeCards.sort(function(a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(a.date) - new Date(b.date);
          });

          for (let i = 0; i <= tempArg.timeCards.length - 1; i++) {
            //iterate all of the times to get a total.
            let daysum = 0;
            for (let t = 0; t <= tempArg.timeCards[i].times.length - 1; t++) {
              tempArg.timeCards[i].times[t] = {
                times: [
                  tempArg.timeCards[i].times[t].startTime.toDate(),
                  tempArg.timeCards[i].times[t].endTime.toDate()
                ],
                type: tempArg.timeCards[i].times[t].type,
                job: tempArg.timeCards[i].times[t].job
                  ? tempArg.timeCards[i].times[t].job
                  : null,
                notes: tempArg.timeCards[i].times[t].notes
              };
              let start = moment(tempArg.timeCards[i].times[t].times[0]);
              let end = moment(tempArg.timeCards[i].times[t].times[1]);
              if (
                !this.holidays.includes(
                  moment(tempArg.timeCards[i].date).format('YYYY-MM-DD')
                )
              ) {
                // daysum += moment.duration(end.diff(start)).asHours();
                daysum += Number(roundToQuarter(moment.duration(end.diff(start)).asHours()));
              }
              if (
                tempArg.timeCards[i].times[t].type == 'travel time' ||
                tempArg.timeCards[i].times[t].type == 'on call' ||
                tempArg.timeCards[i].times[t].type == 'ot exempt'
              ) {
                //the travel time and on call times need to be removed from the weekly ot count.
                daysum -= Number(roundToQuarter(moment.duration(end.diff(start)).asHours()));
              }
            }
            if (tempArg.timeCards[i].type == 'employee') {
              if (roundToQuarter(daysum) >= 8) {
                sum += 8;
                dayAdd = 8;
              } else {
                sum += Number(roundToQuarter(Number(daysum)));
                dayAdd = Number(roundToQuarter(Number(daysum)));
              }

              if (sum >= 44 && index == -1) {
                //x = o-(s-c)
                //x = the regular time that is applied to reach the total of 44 hours worked in a work week.
                //o = the weekly ot maximum.
                //s = weekly sum
                //c = current day's regular hours that would be applied to the sum
                lastHours = 44 - (sum - dayAdd);
                index = i;
              }
            } else if (tempArg.timeCards[i].type == 'driver') {
              if (roundToQuarter(daysum) >= 10) {
                sum += 10;
                dayAdd = 10;
              } else {
                sum += Number(roundToQuarter(Number(daysum)));
                dayAdd = Number(roundToQuarter(Number(daysum)));
              }

              if (sum >= 50 && index === -1) {
                lastHours = 50 - (sum - dayAdd);
                index = i;
              }
            }
          }

          //check to see if there are any duplicate time cards.
          let dateArray = tempArg.timeCards.map(function(item) {
            return item.date;
          }); //create a new array that is just the dates.
          var isDuplicate = dateArray.some(function(item, idx) {
            return dateArray.indexOf(item) != idx; //check if the date exists in the array that isn't the current index.
          });

          if (isDuplicate) {
            //there are incomplete time cards.
            this.duplicateTimeCardErrors.push({
              error: true,
              message: `WARNING: ${
                tempArg.timeCards[0].name
              } has more than one time card on the same day during the week of ${moment(
                startDate
              ).format('MMM DD, YY')} - ${moment(endDate).format(
                'MMM DD, YY'
              )} the Payroll Report may not accurately reflect the user's hours worked.`
            });
          } else {
            //there are incomplete time cards.
            this.duplicateTimeCardErrors.push({
              error: false,
              message: null
            });
          }

          //this is the time card that will go over the weekly maximum
          if (index !== -1) {
            for (let i = index; i < tempArg.timeCards.length; i++) {
              tempArg.timeCards[i].lastRegTime = lastHours;
              tempArg.timeCards[i].otIndex = index;
            }
          }
          if (weekIndex === 0) {
            let tempCollection = [];
            tempCollection.push(tempArg);
            this.timeCardCollection.push({
              employee: employee,
              timeCardCollection: tempCollection,
              hasTimeCards: tempArg.timeCards.length > 0 ? true : false
            });
          } else {
            let possibleIndex = this.timeCardCollection.findIndex(
              o => o.employee.id == employee.id
            );
            this.timeCardCollection[possibleIndex].timeCardCollection.push(
              tempArg
            );
            if (tempArg.timeCards.length > 0) {
              this.timeCardCollection[possibleIndex].hasTimeCards = true;
            }
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //updateData is emitted from reportCalculations upon completion of each employee
    updateData: function(
      totals,
      data,
      employee,
      hoursWorkedTotals,
      jobSpecificTotals,
      hoursWorkedJobSpecificTotals
    ) {
      //if this is the hours worked report, we use the hours worked totals, otherwise we use the totals
      if (this.fromHoursWorked) {
        let index = this.hoursWorkedTotals.findIndex(
          x => x.employee.id === employee.id
        );
        if (index === -1) {
          this.hoursWorkedTotals.push({
            employee: employee,
            totals: hoursWorkedTotals
          });
          // sum the totals
          let sumTotals = {
            employee: null,
            onCallHoursTotal: 0,
            otTotal: 0,
            regularTotal: 0,
            statTotal: 0,
            total: 0,
            travelTimeTotal: 0
          };
          hoursWorkedTotals.forEach(total => {
            sumTotals.employee = employee;
            sumTotals.onCallHoursTotal += Number(total.onCallHoursTotal);
            sumTotals.otTotal += Number(total.otTotal);
            sumTotals.regularTotal += Number(total.regularTotal);
            sumTotals.total += Number(total.total);
            sumTotals.travelTimeTotal += Number(total.travelTimeTotal);
          });
          this.allEmployeeTotals.push(sumTotals);
        }

        this.tableData.push({
          employee: employee,
          data: data
        });

        let index2 = this.hoursWorkedJobSpecificTotals.findIndex(
          x => x.employee.id === employee.id
        );
        if (index2 === -1) {
          // this.jobSpecificTotals.push({ employee: employee, totals: jobSpecificTotals });
          // sum the totals
          let sumTotals = {
            employee: null,
            regular: {},
            ot: {}
          };
          hoursWorkedJobSpecificTotals.forEach(total => {
            for (const [key, value] of Object.entries(total.regular)) {
              if (sumTotals.regular[`${key}`] === undefined) {
                sumTotals.regular[`${key}`] = 0;
              }
              sumTotals.regular[`${key}`] += Number(value);
            }
            for (const [key, value] of Object.entries(total.ot)) {
              if (sumTotals.ot[`${key}`] === undefined) {
                sumTotals.ot[`${key}`] = 0;
              }
              sumTotals.ot[`${key}`] += Number(value);
            }

            sumTotals.employee = employee;
          });
          this.hoursWorkedJobSpecificTotals.push(sumTotals);

          this.allEmployeeJobSpecificTotals.push({
            employee: employee,
            data: hoursWorkedJobSpecificTotals
          });
        }
      } else {
        let index = this.totals.findIndex(x => x.employee.id === employee.id);
        if (index === -1) {
          this.totals.push({ employee: employee, totals: totals });
          // sum the totals
          let sumTotals = {
            employee: null,
            onCallHoursTotal: 0,
            otTotal: 0,
            regularTotal: 0,
            statTotal: 0,
            total: 0,
            travelTimeTotal: 0
          };
          totals.forEach(total => {
            sumTotals.employee = employee;
            sumTotals.onCallHoursTotal += Number(total.onCallHoursTotal);
            sumTotals.otTotal += Number(total.otTotal);
            sumTotals.regularTotal += Number(total.regularTotal);
            sumTotals.total += Number(total.total);
            sumTotals.travelTimeTotal += Number(total.travelTimeTotal);
          });
          this.allEmployeeTotals.push(sumTotals);
        }

        this.tableData.push({
          employee: employee,
          data: data
        });

        let index2 = this.jobSpecificTotals.findIndex(
          x => x.employee.id === employee.id
        );
        if (index2 === -1) {
          // this.jobSpecificTotals.push({ employee: employee, totals: jobSpecificTotals });
          // sum the totals
          let sumTotals = {
            employee: null,
            regular: {},
            ot: {}
          };
          jobSpecificTotals.forEach(total => {
            for (const [key, value] of Object.entries(total.regular)) {
              if (sumTotals.regular[`${key}`] === undefined) {
                sumTotals.regular[`${key}`] = 0;
              }
              sumTotals.regular[`${key}`] += Number(value);
            }
            for (const [key, value] of Object.entries(total.ot)) {
              if (sumTotals.ot[`${key}`] === undefined) {
                sumTotals.ot[`${key}`] = 0;
              }
              sumTotals.ot[`${key}`] += Number(value);
            }

            sumTotals.employee = employee;
          });
          this.jobSpecificTotals.push(sumTotals);

          this.allEmployeeJobSpecificTotals.push({
            employee: employee,
            data: jobSpecificTotals
          });
        }
      }

      //find the last employee that has timecards and check to see if this is them
      let lastIndex = 0;
      for (let i = this.timeCardCollection.length - 1; i >= 0; i--) {
        if (this.timeCardCollection[i].hasTimeCards) {
          lastIndex = i;
          break;
        }
      }
      if (employee.id === this.timeCardCollection[lastIndex].employee.id) {
        this.isLoading = false;
      }
    },
    //updateStatCards is emitted from reportCalculations every time the time card component emits updateStat
    updateStatCards: function(val, index, date, uid, statHoursWorked, statDaysWorked, statExemptDays, statExemptHours) {
      this.statTimeCards.push({ date: date, index: index, val: val, uid: uid, statHoursWorked: statHoursWorked, statDaysWorked: statDaysWorked, statExemptDays: statExemptDays, statExemptHours: statExemptHours });
    },
    getHolidays: async function(startDate, endDate) {
      this.holidays = [];
      let startYear = Number(moment(startDate).format('YYYY'));
      let numberOfYears =
        Number(moment(endDate).format('YYYY')) -
        Number(moment(startDate).format('YYYY'));
      //get the list of holidays for the year that the user has selected.
      for (let i = 0; i <= numberOfYears; i++) {
        await getHolidays(startYear.toString())
          .then(response => {
            for (
              let i = 0;
              i <= response.data.provinces[0].holidays.length - 1;
              i++
            ) {
              this.holidays.push(response.data.provinces[0].holidays[i].date);
            }
          })
          .catch(err => {
            console.log(`Error getting holidays: ${err.message}`);
            this.showError('Unexpected error: Error getting holiday data.');
          });
        startYear++;
      }
    },
    calculateHolidays: function() {
      //add all holidays in the time span selected to an array
      this.holidaysInTimeSpan = [];
      this.holidays.forEach(holiday => {
        if (
          moment(holiday).isBetween(
            this.searchDate[0],
            this.searchDate[1],
            undefined,
            '[]'
          )
        ) {
          holiday = moment(holiday).format('MMM DD, YY');
          if (!this.holidaysInTimeSpan.includes(holiday)) {
            this.holidaysInTimeSpan.push(holiday);
          }
        }
      });
    },
    getJobName(id) {
      if (id && id !== 'default') {
        let job = this.jobs.find(x => x.id === id);
        return job.description;
      }
      return null;
    }
  },
  mounted() {
    this.calculateAllEmployees();
  },
  computed: {
    jobSpecificTimes() {
      return this.$store.state.jobSpecificTimes;
    },
    jobs() {
      return this.$store.state.jobs;
    },
    employeesToShow: function() {
      //if the hide employees without hours flag is true, then filter out these employees.
      let returnedData = [];
      if (this.hideEmployeesWithNoHours) {
        this.allEmployeeTotals.forEach(employee => {
          if (employee.total > 0 || employee.statTotal > 0) {
            returnedData.push(employee);
          }
        });
      } else {
        returnedData = this.allEmployeeTotals;
      }
      return returnedData;
    },
    columnsToShow: function() {
      //any field that has zero hours won't be shown.
      let totals = {
        regular: {
          name: 'Regular Hours',
          dataName: 'regularTotal',
          value: 0
        },
        ot: {
          name: 'OT Hours',
          dataName: 'otTotal',
          value: 0
        },
        travel: {
          name: 'Travel Hours',
          dataName: 'travelTimeTotal',
          value: 0
        },
        onCall: {
          name: 'On Call',
          dataName: 'onCallHoursTotal',
          value: 0
        },
        stat: {
          name: 'Stat Pay',
          dataName: 'statTotal',
          value: 0
        },
        total: {
          name: 'Total Hours',
          dataName: 'total',
          value: 0
        }
      };
      //calculate totals
      this.statTimeCards.forEach(stat => {
        if (this.fromHoursWorked) {
          let employeeIndex = this.hoursWorkedTotals.findIndex(
            x => x.employee.id === stat.uid
          );
          this.tableData[employeeIndex].data.forEach((x, i) => {
            x.timeCards.forEach(card => {
              if (
                moment(card.date).isBetween(
                  this.searchDate[0],
                  this.searchDate[1],
                  undefined,
                  '[]'
                )
              ) {
                if (stat.date === card.date) {
                  if (!isNaN(stat.val) && card.calculated !== true) {
                    card.calculated = true;
                    card.statTime = stat.val;
                    this.hoursWorkedTotals[employeeIndex].totals[i].statTotal =
                      Number(
                        this.hoursWorkedTotals[employeeIndex].totals[i]
                          .statTotal
                      ) + Number(stat.val);

                    this.allEmployeeTotals[employeeIndex].statTotal += Number(
                      stat.val
                    );
                  }
                }
              }
            });
          });
        } else {
          let employeeIndex = this.totals.findIndex(
            x => x.employee.id === stat.uid
          );
          this.tableData[employeeIndex].data.forEach((x, i) => {
            x.timeCards.forEach(card => {
              if (stat.date === card.date) {
                if (!isNaN(stat.val) && card.calculated !== true) {
                  card.calculated = true;
                  card.statTime = stat.val;
                  this.totals[employeeIndex].totals[i].statTotal =
                    Number(this.totals[employeeIndex].totals[i].statTotal) +
                    Number(stat.val);

                  this.allEmployeeTotals[employeeIndex].statTotal += Number(
                    stat.val
                  );
                }
              }
            });
          });
        }
      });

      let allEmployeesStatTotals =[];

      this.allEmployeeTotals.forEach(employee => {
        totals.regular.value += Number(employee.regularTotal);
        totals.ot.value += Number(employee.otTotal);
        totals.travel.value +=
          employee.travelTimeTotal != undefined
            ? Number(employee.travelTimeTotal)
            : 0;
        totals.onCall.value +=
          employee.onCallHoursTotal != undefined
            ? Number(employee.onCallHoursTotal)
            : 0;

        totals.stat.value += Number(employee.statTotal);

        totals.total.value += Number(employee.total);
        
        // get the employees stat totals from the statTimeCards array  
        const employeeUID = employee.employee.id;

        this.statTimeCards.forEach(card =>{
          if(card.uid === employeeUID){
            // check if the employee is in the array
            const employeeIndex = allEmployeesStatTotals.findIndex(x => x.uid === employeeUID);
            if(employeeIndex !== -1){
              allEmployeesStatTotals[employeeIndex].statDaysWorked += card.statDaysWorked;
              allEmployeesStatTotals[employeeIndex].statHoursWorked += card.statHoursWorked;
              allEmployeesStatTotals[employeeIndex].statExemptDays += card.statExemptDays;
              allEmployeesStatTotals[employeeIndex].statExemptHours += card.statExemptHours;
            } else{
              // add the employee to the array
              allEmployeesStatTotals.push({
                uid: employeeUID,
                statDaysWorked: card.statDaysWorked,
                statHoursWorked: card.statHoursWorked,
                statExemptDays: card.statExemptDays,
                statExemptHours: card.statExemptHours
              });
            }
          }
        });
      });

      //filter the array and only keep columns that have hours in them.
      let returnObj = [];
      Object.keys(totals).forEach(total => {
        if (totals[total].value > 0) {
          returnObj.push(totals[total]);
        }
      });

      this.$emit(
        'updateFromAllEmployees',
        this.totals,
        this.tableData,
        this.allEmployeeTotals,
        this.missingTimeCardError,
        this.missingTimeCardMessage,
        this.duplicateTimeCardErrors,
        this.allEmployeeJobSpecificTotals,
        this.hoursWorkedJobSpecificTotals,
        returnObj,
        this.employeesToShow,
        allEmployeesStatTotals,
      );
      return returnObj;
    },
    formattedHeaderDates: function() {
      return {
        startDate: moment(new Date(this.searchDate[0])).format('MMM DD, YY'),
        endDate: moment(new Date(this.searchDate[1])).format('MMM DD, YY')
      };
    }
    // ...mapState(['allEmployeeStatHours'])
  }
};
</script>
